import moment from "moment";
import { Kundorder } from "../../models/KundorderListResponseDTO";
import { DateUtils } from "~app/common/utils/date-utils";

export class KundorderSearchResultViewModel {
    constructor(private readonly model: Kundorder) {
    }

    get id() {
        return this.model.id;
    }

    get kund() {
        return this.model.kund;
    }

    get periodFrom() {
        if (!this.model.periodFrom) {
            return "";
        }

        return moment(this.model.periodFrom).format(DateUtils.dateformat);
    }

    get periodTom() {
        if (!this.model.periodTom) {
            return "";
        }

        return moment(this.model.periodTom).format(DateUtils.dateformat);
    }

    get ordernummer() {
        return this.model.ordernummer;
    }

    get handelssortiment() {
        const hs = this.model && this.model.handelssortiment ? this.model.handelssortiment.map(h => `${h.beteckning} ${h.namn}`) : "";
        const ah = this.model && this.model.alternativaHandelssortiment ? this.model.alternativaHandelssortiment.map(h => `alt-${h.beteckning} ${h.namn}`) : "";
        return [
            ...hs,
            ...ah
        ];
    }

    get mottagningsplats() {
        return this.model && this.model.mottagningsplats ? this.model.mottagningsplats.map(m => `${m.kod} ${m.namn}`) : "";
    }

    get kvantitet() {
        return `${this.model.kvantitet} ${this.model.mattslag}`;
    }

    get avtalsansvarig() {
        return this.model.avtalsansvarig;
    }

    get beskrivning() {
        return this.model.beskrivning;
    }
}
